const DATALAB_REPORT_PAGE_PATH = '@/pages/intelligence/v3/components/DatalabReport';

/**
 * 设置页面路由
 */
export default [
  // 组件文档页面（独立页面，不使用 layouts）
  {
    path: '/intelligence/componentDocs',
    component: '@/pages/intelligence/v3/componentDocs/index',
  },
  // useFilterablePage 测试页面
  {
    path: '/intelligence/filterable-page-demo',
    component: '@/pages/intelligence/v3/pages/FilterablePageDemo/index',
  },
  {
    path: '/intelligence/filterable-page-demo/detail',
    component: '@/pages/intelligence/v3/pages/FilterablePageDemo/Detail',
  },
  {
    path: '/intelligence/download',
    component: '@/pages/intelligence/pages/Download/index',
  },
  {
    path: '/intelligence/pdfPreviewDownload',
    component: '@/pages/intelligence/pages/PDFPreviewDownload/index',
  },
  {
    path: './intelligence/downloadCommon',
    component: '@/pages/intelligence/components/DownloadCommon/DownloadPage/index',
  },
  {
    path: '/intelligence/pdfPreviewDownloadLikeShare',
    component: '@/pages/intelligence/pages/PDFPreviewDownloadLikeShare/index',
  },
  // 报告详情页中转页面
  {
    path: '/intelligence/reportDetails/:systemId/:resourceId',
    component: '@/pages/intelligence/v3/pages/ReportDetailsMiddlePage/index',
  },
  {
    path: '/intelligence',
    component: '@/pages/intelligence/layouts/index',
    routes: [
      {
        path: './authPath/report/:reportId',
        component: '@/pages/intelligence/pages/authPath/index',
      },
      {
        path: './ipCollaboration',
        component: '@/pages/intelligence/pages/IpCollaboration/index',
      },
      {
        path: './marketProfile',
        routes: [
          {
            path: './:tab?',
            component: '@/pages/intelligence/pages/MarketProfile/index',
          },
          {
            path: './:tab?/detail',
            component: '@/pages/intelligence/pages/MarketProfile/TabDetails/index',
          },
        ],
      },
      {
        path: './mobileDevice',
        component: '@/pages/intelligence/pages/MobileDevice/Stats/index',
        // routes: [
        //   {
        //     path: './overview',
        //     component: '@/pages/intelligence/pages/MobileDevice/Overview/index',
        //   },
        //   {
        //     path: './stats',
        //     component: '@/pages/intelligence/pages/MobileDevice/Stats/index',
        //   },
        //   {
        //     path: './reports',
        //     component: '@/pages/intelligence/pages/MobileDevice/Reports/index',
        //     // component: '@/pages/intelligence/pages/BusinessReports/Mobile/index',
        //   },
        // ],
      },
      {
        path: './casualDailyReports',
        component: '@/pages/intelligence/v3/pages/CasualDailyReports/index',
      },
      {
        path: './aiDailyNews/globalGamingDynamics',
        component: '@/pages/intelligence/v3/pages/CasualWordlWide/index',
      },
      {
        path: './topCharts',
        routes: [
          {
            path: './mobileGames/:tab?',
            component: '@/pages/intelligence/v3/pages/TopCharts/MobileGames',
          },
          // 等做pc console详情页开发的时候，再用此路由
          // {
          //   path: './:entityType/gamesDetails/:id/:tab?/:segment?',
          //   component:
          //     '@/pages/intelligence/pages/TopCharts/MobileGames/components/GamesDetails/index',
          // },

          // 临时
          {
            path: './mobileGames/gamesDetails/:id/:tab?/:segment?',
            component: '@/pages/intelligence/pages/TopCharts/MobileGames/components/GamesDetails/index',
          },

          {
            path: './companies/:tab?',
            component: '@/pages/intelligence/pages/TopCharts/Companies/index',
          },
          {
            path: './companies/gamesDetails/:id/:tab/:segment?',
            component: '@/pages/intelligence/pages/TopCharts/Companies/components/GamesDetails/index',
          },
          {
            path: './pcGames/:tab?',
            component: '@/pages/intelligence/pages/TopCharts/PCGames/index',
          },
          {
            path: './pcGames/gamesDetails/:id/:tab?/:segment?',
            component: '@/pages/intelligence/pages/TopCharts/PCGames/components/GamesDetails/index',
          },
          {
            path: './consoleGames/:tab?',
            component: '@/pages/intelligence/pages/TopCharts/ConsoleGames/index',
          },
          {
            path: './consoleGames/gamesDetails/:id/:tab?/:segment?',
            component: '@/pages/intelligence/pages/TopCharts/ConsoleGames/components/GamesDetails/index',
          },
          {
            path: './pcConsoleGames/:tab?',
            component: '@/pages/intelligence/pages/TopCharts/PCConsoleGames/index',
          },
          {
            path: './pcConsoleGames/gamesDetails/:id/:tab?/:segment?',
            component: '@/pages/intelligence/pages/TopCharts/PCConsoleGames/components/GamesDetails/index',
          },
          {
            path: './eventDetails',
            component: '@/pages/intelligence/v3/pages/OpinionEventDetails/index',
          },
        ],
      },
      {
        path: './potential',
        routes: [
          {
            path: './newReleaseGames/:tab?',
            component: '@/pages/intelligence/pages/Potential/NewReleaseGames/index',
          },
          {
            path: './upcomingGames/:tab?',
            component: '@/pages/intelligence/pages/Potential/UpcomingGames/index',
          },
          {
            path: './steamMetrics',
            component: '@/pages/intelligence/pages/Potential/SteamMetrics/index',
          },
        ],
      },
      {
        path: './sourcesMetrics',
        routes: [
          {
            path: './overview',
            component: '@/pages/intelligence/pages/SourcesMetrics/Overview/index',
          },
          {
            path: './Sources/:tab?',
            component: '@/pages/intelligence/pages/SourcesMetrics/Sources/index',
          },
          {
            path: './Metrics/:tab?',
            component: '@/pages/intelligence/pages/SourcesMetrics/Metrics/index',
          },
        ],
      },
      {
        path: './storeRanks',
        routes: [
          {
            path: './MobileGlobalRegion/:tab?',
            component: '@/pages/intelligence/pages/StoreRanks/MobileGlobalRegion/index',
          },
          // {
          //   // path: './MobileGlobalRegion/more/:id',
          //   path: './MobileGlobalRegion/:tab?/more',
          //   component: '@/pages/intelligence/pages/StoreRanks/MobileGlobalRegion/page/more/index',
          // },
          {
            // path: './MobileGlobalRegion/more/:id',
            path: './MobileGlobalRegion/more/:tab?',
            component: '@/pages/intelligence/pages/StoreRanks/MobileGlobalRegion/page/more/index',
          },
          {
            path: './PCGlobal/:tab?',
            component: '@/pages/intelligence/pages/StoreRanks/PCGlobal/index',
          },
          {
            path: './PCGlobal/more/:tab?',
            component: '@/pages/intelligence/pages/StoreRanks/PCGlobal/page/more/index',
          },
          {
            path: './ConsoleRegion/:tab?',
            component: '@/pages/intelligence/pages/StoreRanks/ConsoleRegion/index',
          },
          {
            path: './ConsoleRegion/more/:tab?',
            component: '@/pages/intelligence/pages/StoreRanks/ConsoleRegion/page/more/index',
          },
        ],
      },
      {
        path: './streaming',
        routes: [
          {
            path: './influencer',
            component: '@/pages/intelligence/pages/Streaming/Kol/page/index',
          },
          {
            path: './influencer/details/:tab?',
            component: '@/pages/intelligence/pages/Streaming/Kol/details/index',
          },
          {
            path: './games',
            component: '@/pages/intelligence/pages/Streaming/Games/index',
          },
        ],
      },
      {
        path: './genreProfile',
        routes: [
          {
            path: './:tab?',
            component: '@/pages/intelligence/pages/GenreProfile/index',
          },
          {
            path: './:tab?/detail/:tab',
            component: '@/pages/intelligence/pages/GenreProfile/Detailspage/index',
          },
        ],
      },
      {
        path: './following',
        routes: [
          {
            path: './manage/:tab?',
            component: '@/pages/intelligence/pages/Following/Manage/index',
          },
          {
            path: './:tab?',
            component: '@/pages/intelligence/pages/Following/index',
          },
        ],
      },
      // {
      //   path: './insightsReports',
      //   component: '@/pages/intelligence/pages/InsightsReport/index',
      // },
      // {
      //   path: './iMurReports',
      //   component: '@/pages/intelligence/pages/iMurReports/index',
      // },
      // {
      //   path: './marketReports',
      //   component: '@/pages/intelligence/pages/BusinessReports/index',
      // },
      {
        path: './reports',
        routes: [
          {
            path: './reportSearch',
            component: '@/pages/intelligence/pages/ReportSearch/index',
          },
          {
            path: './aiHubReports',
            component: '@/pages/intelligence/pages/AIHubReports/index',
          },
          {
            path: './trendingGames/:uid?/:ver?',
            component: '@/pages/intelligence/pages/TrendingGames/index',
          },
          {
            path: './marketReports',
            component: '@/pages/intelligence/pages/BusinessReports/index',
          },
          {
            path: './insightsReports',
            component: '@/pages/intelligence/pages/InsightsReport/index',
          },
          {
            path: './insightsCenterLibrary',
            component: '@/pages/intelligence/pages/InsightsCenterLibrary/index',
          },
          {
            path: './iMurReports',
            component: '@/pages/intelligence/pages/iMurReports/index',
          },
          {
            path: 'socDiscountReport',
            component: '@/pages/intelligence/v3/pages/LowCodeTemplateWrapper',
          },
          {
            path: './gameAnalysis',
            component: '@/pages/intelligence/pages/GameAnalysis/index',
          },
        ],
      },
      {
        path: './compare',
        routes: [
          {
            path: './mobileGames/:tab?',
            component: '@/pages/intelligence/pages/Compare/MobileGames/index',
          },
          {
            path: './PcConsoleGamesBeta/:tab?',
            component: '@/pages/intelligence/pages/Compare/PcConsoleGamesBeta/index',
          },
          {
            path: './pcConsoleGames/:tab?',
            component: '@/pages/intelligence/pages/Compare/PcConsoleGames/index',
          },
        ],
      },
      {
        path: './globalView',
        routes: [
          {
            path: './marketSize/:tab?',
            component: '@/pages/intelligence/pages/GlobalView/MarketSize/index',
          },
          {
            path: './TopGenreperMarket',
            component: '@/pages/intelligence/pages/GlobalView/TopGenrePerMarket/index',
          },
          {
            path: './TopMarketperGenre',
            component: '@/pages/intelligence/pages/GlobalView/TopMarketPerGenre/index',
          },
        ],
      },
      {
        path: 'metricsCreditability',
        component: '@/pages/intelligence/pages/MetricsCreditability',
      },
      // {
      //   path: './trendingGames/:uid?/:ver?',
      //   component: '@/pages/intelligence/pages/TrendingGames/index',
      // },
      {
        path: './IPLibrary/:tab',
        component: DATALAB_REPORT_PAGE_PATH,
      },
      {
        path: './benchmark',
        routes: [
          {
            path: './mobileGameBenchmark',
            component: '@/pages/intelligence/pages/MobileGameBenchmark/index',
          },
          {
            path: './pcConsoleBenchmark',
            component: '@/pages/intelligence/pages/PCConsoleBenchmark/index',
          },
        ],
      },
      {
        path: './overlapAnalysis',
        routes: [
          {
            path: './MobileGames',
            component: '@/pages/intelligence/pages/OverlapAnalysis/MobileGames',
          },
          {
            path: './steamGames',
            component: '@/pages/intelligence/pages/OverlapAnalysis/SteamGames',
          },
        ],
      },
      {
        path: './gameResearchReport',
        component: '@/pages/intelligence/pages/GameResearchReport/index',
      },
      {
        path: './aiDailyNews/:templateName',
        component: '@/pages/intelligence/v3/pages/LowCodeTemplateWrapper',
      },
      // v3 图表组件测试页面 默认注释，需要查看demo时解开路由注释
      // {
      //   path: './chartsTest',
      //   routes: [
      //     {
      //       path: './bar',
      //       component: '@/pages/intelligence/v3/pages/ChartsTest/BarChartTest/index',
      //     },
      //     {
      //       path: './pie',
      //       component: '@/pages/intelligence/v3/pages/ChartsTest/PieChartTest/index',
      //     },
      //     {
      //       path: './line',
      //       component: '@/pages/intelligence/v3/pages/ChartsTest/LineChartTest/index',
      //     },
      //   ],
      // },
      {
        path: './casualGamesHub',
        routes: [
          {
            path: './casualGamesOverview',
            component: '@/pages/intelligence/v3/pages/CasualHubCompetitorsBridge',
          },
          {
            path: './keyGames',
            component: '@/pages/intelligence/v3/pages/ReusePages/KeyGames',
          },
          {
            path: './arrowsTopCharts',
            component: '@/pages/intelligence/v3/pages/ReusePages/ArrowsTopCharts',
          },
          {
            path: './casualTopChartsAM/:tab?',
            component: '@/pages/intelligence/v3/pages/ReusePages/CasualTopChartsAM',
          },
          {
            path: './casualTopChartsST/:tab?',
            component: '@/pages/intelligence/v3/pages/ReusePages/CasualTopChartsST',
          },
          {
            path: './casualTopChartsMahjong/:tab?',
            component: '@/pages/intelligence/v3/pages/ReusePages/CasualTopChartsMahjong',
          },
          {
            path: './narrativeMerge2TopCharts',
            component: '@/pages/intelligence/v3/pages/ReusePages/NarrativeMerge2TopCharts',
          },
          {
            path: './casualGamesStoreRanks/:tab?',
            component: '@/pages/intelligence/v3/pages/ReusePages/CasualGamesStoreRanks',
          },
          {
            path: './casualMiniGameRankings/gamesDetails/:id',
            component: '@/pages/intelligence/v3/pages/MiniGameDetails',
          },
          {
            path: './casualMiniGameRankings/more/:tab?',
            component: '@/pages/intelligence/v3/pages/ReusePages/CasualMiniGameRankings/components/More',
          },
          {
            path: './casualMiniGameRankings/:tab?',
            component: '@/pages/intelligence/v3/pages/ReusePages/CasualMiniGameRankings',
          },
          {
            path: './robloxGameRank',
            component: '@/pages/intelligence/v3/pages/RobloxGameRank',
          },
          {
            path: './robloxTopCharts',
            component: '@/pages/intelligence/v3/pages/RobloxTopCharts',
          },
          {
            path: './gamesOverlap',
            component: '@/pages/intelligence/v3/pages/ReusePages/GamesOverlap',
          },
          {
            path: './genreAnalysis',
            component: DATALAB_REPORT_PAGE_PATH,
          },
          {
            path: './casualGenreProfile',
            component: '@/pages/intelligence/v3/pages/CasualGenreProfile',
          },
          {
            path: './reports',
            routes: [
              {
                path: './',
                redirect: './marketReports',
              },
              {
                path: './marketReports',
                component: '@/pages/intelligence/v3/pages/ReusePages/CasualGamesReports',
              },
              {
                path: './analysisReports',
                component: '@/pages/intelligence/v3/pages/ReusePages/CasualGamesReports',
              },
            ],
          },
          {
            path: './IAABenchmarks',
            component: '@/pages/intelligence/v3/pages/LowCodeTemplateWrapper',
          },
        ],
      },
      {
        path: '*',
        component: '@/pages/home/pages/NotFound/index',
      },
    ],
  },
];
